
import Checkbox from './Checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./components/vc-checkbox/src/index.js